import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { LoginComponent } from 'src/app/modules/auth/login/login.component';
import { SignupComponent } from 'src/app/modules/auth/signup/signup.component';
import { AuthService } from 'src/app/modules/auth/services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-side-header',
  templateUrl: './side-header.component.html',
  styleUrls: ['./side-header.component.scss']
})
export class SideHeaderComponent implements OnInit {

  

  constructor(public dialog: MatDialog,public authService : AuthService,private router: Router) { }

  ngOnInit() {
  }


  openLogin() : void{
    /*let dialogRef = this.dialog.open(LoginComponent, {
      width: '350px'
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });*/
    this.router.navigate(['auth']);

  }

  openSignup() : void{
    /*let dialogRef = this.dialog.open(SignupComponent, {
      width: '350px'
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
    */
    this.router.navigate(['auth']);

  }

/**
 * Logout user and send him to home page
 */
  logoutUser() : void {

    this.authService.logout()
    .then(res => {
        this.onLogoutSuccess(res);
    }, err => {
      this.onLogoutError(err);  
    });
  
  }

  /**
   * Logout success 
   */
  onLogoutSuccess(res) : void{
    this.router.navigate(['']);
  }

  /**
   * Logout Error
   */
  onLogoutError(err) : void{

  }




}
